/**
 * Initiales tirées d'un nom.
 */
export function getInitials(name: string): string {
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

/**
 * Date calculée à partir d'un décalage relatif (en jours depuis aujourd'hui).
 * Sert aux contenus de mails paramétrés.
 * @param dateRelative - Nombre de jours par rapport à aujourd'hui (négatif = passé, positif = futur)
 * @param todayDate - Date de référence (par défaut, la date courante)
 */
export function calculateDateWithDateRelative(
  dateRelative: number,
  todayDate: Date = new Date(),
): string {
  const date = new Date(todayDate);
  date.setDate(date.getDate() + dateRelative);
  return date.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

// 20 couleurs visuellement distinctes, réparties sur la roue des teintes
const SENDER_COLOR_PALETTE = [
  "hsl(4, 70%, 55%)",
  "hsl(25, 70%, 52%)",
  "hsl(45, 65%, 48%)",
  "hsl(75, 55%, 48%)",
  "hsl(100, 55%, 48%)",
  "hsl(130, 50%, 48%)",
  "hsl(160, 55%, 46%)",
  "hsl(185, 60%, 47%)",
  "hsl(205, 65%, 52%)",
  "hsl(225, 60%, 55%)",
  "hsl(250, 55%, 57%)",
  "hsl(270, 55%, 55%)",
  "hsl(290, 55%, 52%)",
  "hsl(315, 60%, 52%)",
  "hsl(340, 65%, 52%)",
  "hsl(15, 60%, 52%)",
  "hsl(55, 60%, 46%)",
  "hsl(145, 50%, 46%)",
  "hsl(195, 65%, 48%)",
  "hsl(235, 58%, 56%)",
];

/**
 * Couleur de fond déterministe dérivée du nom d'un émetteur.
 * Puisée dans une palette de couleurs visuellement distinctes, pour que deux
 * émetteurs différents aient peu de chances de partager la même couleur.
 */
export function getSenderColor(name: string): string {
  let hash = 5381;
  for (let i = 0; i < name.length; i++) {
    hash = ((hash << 5) + hash) ^ name.charCodeAt(i);
    hash |= 0;
  }
  return SENDER_COLOR_PALETTE[Math.abs(hash) % SENDER_COLOR_PALETTE.length]!;
}
